import {
  UserLocation,
  fetchUserLocation as apiFetchUserLocation,
} from 'api/userLocation';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle, no-restricted-imports
import { Dispatch, GetState } from '..';

// Types

export type State = UserLocation & {
  isFetching?: boolean;
  isLoaded?: boolean;
};

type FetchUserLocationRequestAction = {
  type: 'USER_LOCATION_FETCH_REQUEST';
};
type FetchUserLocationSuccessAction = {
  type: 'USER_LOCATION_FETCH_SUCCESS';
  userLocation: UserLocation;
};
export type Action =
  | FetchUserLocationRequestAction
  | FetchUserLocationSuccessAction;

// Reducer

// TODO: Fix this the next time the file is edited.
// @ts-expect-error ts-migrate(2322) FIXME: Type '{}' is not assignable to type 'State'.
// eslint-disable-next-line @typescript-eslint/default-param-last, import/no-default-export
export default function userLocationReducer(state: State = {}, action: Action) {
  switch (action.type) {
    case 'USER_LOCATION_FETCH_REQUEST':
      return { ...state, isFetching: true };

    case 'USER_LOCATION_FETCH_SUCCESS':
      return { ...action.userLocation, isFetching: false, isLoaded: true };

    default:
      return state;
  }
}

// Actions

const fetchUserLocationRequest = (): FetchUserLocationRequestAction => ({
  type: 'USER_LOCATION_FETCH_REQUEST',
});

const fetchUserLocationSuccess = (
  userLocation: UserLocation
): FetchUserLocationSuccessAction => ({
  type: 'USER_LOCATION_FETCH_SUCCESS',
  userLocation,
});

export const fetchUserLocation =
  () => (dispatch: Dispatch, getState: GetState) => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line prefer-destructuring
    const userLocation = getState().userLocation;

    if (userLocation.isFetching || userLocation.isLoaded) {
      return Promise.resolve() as Promise<void>;
    }

    dispatch(fetchUserLocationRequest());
    return apiFetchUserLocation().then((fetchedUserLocation) =>
      dispatch(fetchUserLocationSuccess(fetchedUserLocation))
    );
  };
